const alertDefaultStyle = (theme, displayCloseButton) => ({
  '&.MuiAlert-root': {
    padding: 0,
    alignItems: 'center',
    border: 'unset'
  },
  '.MuiAlert-message': {
    fontFamily: theme.tokens.ComponentAlertFontName,
    fontSize: theme.tokens.ComponentAlertFontSize,
    fontWeight: theme.tokens.ComponentAlertFontWeight,
    lineHeight: theme.tokens.ComponentAlertFontLineHeight,
    color: theme.tokens.ComponentAlertFontColor,
    padding: '12px 0',
    a: {
      fontWeight: theme.tokens.ComponentAlertLinkFontWeight,
      color: theme.tokens.ComponentAlertFontColor
    }
  },
  '& .MuiAlert-icon': {
    paddingRight: '12px',
    paddingLeft: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0
  },
  '.MuiAlert-action': {
    paddingRight: displayCloseButton ? '12px' : 0,
    paddingTop: '12px',
    paddingLeft: displayCloseButton ? '16px' : '12px',
    paddingBottom: 0,
    marginRight: 0,
    alignSelf: 'flex-start',
    '.ids-alert-close-btn': {
      borderRadius: theme.tokens.ComponentAlertCloseButtonRadius,
      color: theme.tokens.ComponentAlertCloseButtonColor,
      svg: {
        height: '20px',
        width: '20px'
      }
    }
  }
});
export default alertDefaultStyle;